import fastdom from 'fastdom'

function init() {
  window.addEventListener('resize', function() {
    fastdom.mutate(function() {
      document.documentElement.style.setProperty('--window-height', window.innerHeight + 'px');
    });
  });
}

export default init